import { IPincodeInitialState } from "../../../types/master/pincodeInterface";

import {
  PincodeActionTypes,
  PincodeActions,
} from "../../actionTypes/master/pincodeActionTypes";

const initialState: IPincodeInitialState = {
  pincodeList: [],

  pincodeData: {
    id: 0,
    pincode: "",

    // Location
    locality: "",
    district_id: 0,

    // Service options
    cod: false,
    pre_paid: false,
    cash: false,
    pickup: "",
    delivery: "",

    // Status
    status: "ACTIVE",

    // Office mapping
    branch_id: null,
    franchise_id: null,
    branch: {},

    district: {
      id: 0,
      district_name: "",
      state: {
        id: 0,
        state_name: "",
      },
      zone: {},
    },

    // Pricing zone
    pricing_zone_id: null,
    pricing_zone: {
      id: 0,
      zone_name: "",
    },
  },

  pincodeListPageCount: 0,
};

export default function pincodeReducer(
  state = initialState,
  action: PincodeActionTypes
): IPincodeInitialState {
  switch (action.type) {
    case PincodeActions.SET_PINCODE_LIST:
      return {
        ...state,
        pincodeList: action.payload,
      };

    case PincodeActions.SET_PINCODE_LIST_PAGE_COUNT:
      return {
        ...state,
        pincodeListPageCount: action.payload,
      };

    case PincodeActions.SET_PINCODE_DATA_BY_PINCODE:
      return {
        ...state,
        pincodeData: action.payload,
      };

    default:
      return state;
  }
}